import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import AuthSuccess from "@/pages/AuthSuccess";
import AuthCallback from "@/pages/AuthCallback";
import BusinessSetup from "@/pages/BusinessSetup";
import Dashboard from "@/pages/Dashboard";
import Appointments from "@/pages/Appointments";
import Vendors from "@/pages/Vendors";
import Finance from "@/pages/Finance";
import BusinessSettings from "@/pages/settings/BusinessSettings";
import TeamMembers from "@/pages/settings/TeamMembers";
import Automation from "@/pages/settings/Automation";
import Services from "@/pages/settings/Services";
import Landing from "@/pages/Landing";
import AIOrb from "@/components/AIOrb";
import { useAuth } from "@/context/AuthContext";
import BusinessProfile from "@/pages/BusinessProfile";
import Receptionist from "./pages/AIReceptionist/Receptionist";
import SetupReceptionist from "./pages/AIReceptionist/SetupReceptionist";

// Detect Google OAuth callback (#session_id=...) BEFORE normal routing.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  const { user } = useAuth();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Routes>
      <Route path="/" element={user ? <Navigate to="/dashboard" replace /> : <Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />

      <Route path="/auth-success" element={<ProtectedRoute><AuthSuccess /></ProtectedRoute>} />
      <Route path="/business-setup" element={<ProtectedRoute><BusinessSetup /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/appointments" element={<ProtectedRoute><Appointments /></ProtectedRoute>} />
      <Route path="/vendors" element={<ProtectedRoute><Vendors /></ProtectedRoute>} />
      <Route path="/invoices" element={<ProtectedRoute><Vendors /></ProtectedRoute>} />
      <Route path="/finance" element={<ProtectedRoute><Finance /></ProtectedRoute>} />
      <Route path="/business-settings" element={<ProtectedRoute><BusinessSettings /></ProtectedRoute>} />
      <Route path="/business-settings/team" element={<ProtectedRoute><TeamMembers /></ProtectedRoute>} />
      <Route path="/business-settings/services" element={<ProtectedRoute><Services /></ProtectedRoute>} />
      <Route path="/business-settings/automation" element={<ProtectedRoute><Automation /></ProtectedRoute>} />
      <Route path="/receptionist" element={<ProtectedRoute><Receptionist /></ProtectedRoute>} />
      <Route path="/receptionist/setup" element={<ProtectedRoute><SetupReceptionist /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
      <Route
        path="/business-settings/profile"
        element={<BusinessProfile />}
      />
      </Routes>
      {/* {user && <AIOrb />} */}
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" theme="light" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
